// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!../../@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!../../postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./vuetify.min.css?vue&type=style&index=1&id=1fa5cf27&prod&scoped=true&lang=css&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add CSS to Shadow Root
var add = require("!../../vue-style-loader/lib/addStylesShadow.js").default
module.exports.__inject__ = function (shadowRoot) {
  add("21f078b6", content, shadowRoot)
};